import { GeneralFileNodeType } from "@/enums/DocumentCenterFileType";
import { DataRoomEntry } from "@/pages/OneDataRoomPage";

export enum DATA_ROOM_STATIC_ID {
  // CAT 1
  CORPORATE = 0,

  CORPORATE_RECORDS = 1,
  ANNUAL_REPORTS = 2,
  BY_LAWS = 3,
  CHARTER_DOCUMENTS = 4,
  CORPORATE_ORGANIZATIONAL_CHART = 5,
  FOREIGN_STATE_REGISTRATION = 6,
  FOUNDERS_AGREEMENT = 7,
  LLC_CONVERSION = 8,
  CORPORATE_RECORDS_OTHER = 9,
  REGISTERED_AGENT = 10,

  CORPORATE_GOVERNANCE = 11,
  BOARD_BOOKS = 12,
  BOARD_COMMITTEES = 13,
  BOARD_COMMITTEES_COMMITTEE_CHARTERS = 14,
  CODE_OF_ETHICS = 15,
  DIRECTOR_OR_OFFICER_INDEMNIFICATION_AGREEMENTS = 16,
  MINUTES = 17,
  MINUTES_BOARD_MEETINGS = 18,
  MINUTES_COMMITTEE_MEETINGS = 19,
  MINUTES_COMMITTEE_MEETINGS_AUDIT_COMMITTEE = 20,
  MINUTES_COMMITTEE_MEETINGS_COMPENSATION_COMMITTEE = 21,
  MINUTES_STOCKHOLDER_MEETINGS = 22,
  RESIGNATION = 23,
  WRITTEN_CONSENTS = 24,
  WRITTEN_CONSENTS_BOARD_COMMITTEES = 25,
  WRITTEN_CONSENTS_BOARD_COMMITTEES_AUDIT_COMMITTEE = 26,
  WRITTEN_CONSENTS_BOARD_COMMITTEES_COMPENSATION_COMMITTEE = 27,
  WRITTEN_CONSENTS_BOARD_OF_DIRECTORS = 28,
  WRITTEN_CONSENTS_STOCKHOLDERS = 29,

  INSURANCE = 30,
  INSURANCE_CLAIMS_OR_NOTICES_OF_CIRCUMSTANCES = 31,
  INSURANCE_POLICIES = 32,
  INSURANCE_POLICIES_D_AND_O_INSURANCE = 33,
  INSURANCE_POLICIES_KEY_PERSON_INSURANCE = 34,

  LITIGATION = 35,
  DEMAND_LETTERS = 36,
  EXTERNAL_OR_INTERNAL_INVESTIGATIONS = 37,
  PLEADINGS = 38,
  REGULATORY_ENFORCEMENT_ACTION = 39,
  LITIGATION_SETTLEMENT_AGREEMENTS = 40,
  LITIGATION_SUBPOENAS = 41,

  PROPERTIES_ASSETS_AND_LEASES = 42,
  ENVIRONMENTAL_REPORTS = 43,
  LEASES = 44,
  PURCHASE_AND_SALE_AGREEMENTS = 45,
  SUBLEASES = 46,
  PROPERTIES_ASSETS_AND_LEASES_SETTLEMENT_AGREEMENTS = 47,
  PROPERTIES_ASSETS_AND_LEASES_SUBPOENAS = 182,

  ACQUISITIONS = 48,

  REGULATORY_AND_COMPLIANCE = 49,
  ALL_SEC_AND_BLUE_SKY_FILINGS = 50,
  AUDIT_REPORTS = 51,
  GOVERNMENT_AUTHORIZATIONS_LICENSES_OR_PERMITS = 52,
  REGULATORY_FILINGS = 53,

  // CAT 2
  HUMAN_RESOURCES = 54,

  ADVISOR_AGREEMENTS = 55,

  BACKGROUND_CHECKS = 56,
  BACKGROUND_CHECKS_CONSENTS = 57,
  BACKGROUND_CHECKS_RESULTS = 58,

  BENEFITS_ENROLLMENTS = 59,

  CODE_OF_CONDUCT = 60,

  COMPANY_INFO = 61,

  COMPANY_POLICIES = 62,
  COMPANY_POLICIES_POLICY_ACCEPTANCES = 63,

  COMPENSATION = 64,

  BONUS_PLAN = 65,

  RETENTION_PLAN = 66,

  SALES_COMMISSION_PLAN = 67,

  CONSULTANT_AGREEMENTS = 68,

  DIRECT_DEPOSIT_ENROLLMENTS = 69,

  EEO_SURVEYS = 70,

  EMPLOYEE_AGREEMENTS = 71,
  EMPLOYEE_AGREEMENTS_COMPENSATION = 72,
  EMPLOYEE_AGREEMENTS_OTHER = 73,

  EMPLOYEE_BENEFIT_PROGRAMS = 74,

  EMPLOYEE_CONFIDENTIALITY_AND_IP_ASSIGNMENT_AGREEMENTS = 75,

  EMPLOYEE_FORMS = 76,

  EMPLOYEE_HANDBOOK = 77,

  EMPLOYEE_JOB_CHANGE = 78,

  I_94_FORMS = 79,

  I_9_EVIDENCE = 80,

  I_9_FORMS = 81,

  JOB_DESCRIPTIONS = 82,

  MISCELLANEOUS = 83,

  OFFER_LETTERS = 84,

  OFFER_LETTERS_EMPLOYMENT_CONTINGENCY_RESULTS = 85,

  HUMAN_RESOURCES_ORGANIZATIONAL_CHART = 86,

  HUMAN_RESOURCES_OTHER = 87,

  PERFORMANCE_MANAGEMENT = 88,
  PERFORMANCE_MANAGEMENT_PERFORMANCE_IMPROVEMENT_PLANS = 89,
  PERFORMANCE_MANAGEMENT_PERFORMANCE_REVIEW = 90,

  RESUMES = 91,

  SEPARATION_DOCUMENTS = 92,

  W_4_FORMS = 93,

  W_9_FORMS = 94,

  WORKERS_COMPENSATION = 95,

  // CAT 3
  STOCKHOLDER_INFORMATION = 96,

  CAPITALIZATION_TABLE = 97,

  EQUITY_VALUATION_REPORTS = 98,
  EQUITY_VALUATION_REPORTS_409A_VALUATION = 99,
  EQUITY_VALUATION_REPORTS_ASC_718 = 100,
  EQUITY_VALUATION_REPORTS_DRAFTS = 101,
  EQUITY_VALUATION_REPORTS_FAIR_MARKET_VALUE_REQUEST_MATERIALS = 102,

  IRS_FILINGS = 103,
  IRS_FILINGS_3921 = 104,
  IRS_FILINGS_83_B = 105,

  RESTRICTED_STOCK_UNIT_AGREEMENTS = 106,

  RIGHT_OF_FIRST_REFUSAL_AND_CO_SALE_AGREEMENT = 107,

  STOCK_CANCELLATION = 108,

  STOCK_CERTIFICATES = 109,

  STOCKHOLDER_AGREEMENTS = 110,

  STOCKHOLDER_CONSENTS = 111,

  STOCKHOLDER_COMMUNICATIONS = 112,

  STOCK_INCENTIVE_PLANS = 113,

  STOCK_LEDGER = 114,

  STOCK_OPTION_AGREEMENTS = 115,
  STOCK_OPTION_AGREEMENTS_EXERCISE_NOTICE = 116,
  STOCK_OPTION_AGREEMENTS_EXERCISE_NOTICE_EXERCISE_EVIDENCE = 117,

  STOCK_PURCHASE_AGREEMENTS = 118,
  STOCK_PURCHASE_AGREEMENTS_ADDITIONAL_AGREEMENTS = 119,
  STOCK_PURCHASE_AGREEMENTS_COMMON_STOCK = 120,
  STOCK_PURCHASE_AGREEMENTS_COMMON_STOCK_PURCHASE_EVIDENCE = 121,
  STOCK_PURCHASE_AGREEMENTS_COMMON_STOCK_STOCK_RESTRICTION_AGREEMENTS = 122,
  STOCK_PURCHASE_AGREEMENTS_PREFERRED_STOCK = 123,

  STOCK_PURCHASE_EVIDENCE = 124,

  STOCK_REPURCHASE_AGREEMENTS = 125,
  STOCK_REPURCHASE_AGREEMENTS_REPURCHASE_EVIDENCE = 126,

  STOCK_TRANSFER_AGREEMENTS = 127,

  WARRANT_AGREEMENTS = 128,

  // CAT 4
  OPERATIONS = 129,

  BUSINESS_CONTINUITY_PLAN = 130,

  CLIENT_AGREEMENTS = 131,

  DISTRIBUTOR_AGREEMENTS = 132,

  NON_DISCLOSURE_AGREEMENTS = 133,

  PARTNERSHIP_AGREEMENTS = 134,

  STRATEGIC_OR_BUSINESS_PLANS = 135,

  VENDOR_OR_SUPPLIER_AGREEMENTS = 136,

  // CAT 5
  INTELLECTUAL_PROPERTY = 137,

  COPYRIGHTS = 138,

  DOMAIN_NAME_REGISTRATION = 139,

  END_USER_AGREEMENTS = 140,

  IP_ASSIGNMENTS = 141,

  LICENSE_AGREEMENTS = 142,

  PATENTS = 143,

  PUBLIC_DOMAIN_OR_OPEN_SOURCE = 144,

  SOURCE_CODE_ESCROW_AGREEMENTS = 145,

  TRADEMARKS = 146,

  // CAT 6
  FINANCE = 147,

  BUDGETS_AND_PROJECTIONS = 148,

  EXTERNAL_AUDITOR_REPORTS_AND_MANAGEMENT_GETTERS = 149,

  FEDERAL_STATE_AND_OTHER_TAX_FILINGS = 150,
  FEDERAL_STATE_AND_OTHER_TAX_FILINGS_FORM_1120 = 151,
  FEDERAL_STATE_AND_OTHER_TAX_FILINGS_FORM_5500 = 152,

  FINANCIAL_STATEMENTS = 153,
  FINANCIAL_STATEMENTS_AUDITED = 154,
  FINANCIAL_STATEMENTS_UNAUDITED = 155,

  FINANCE_OTHER = 156,

  TAX = 157,

  FINANCING = 158,
  FINANCING_DEBT = 159,
  FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES = 160,
  FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES_NOTE_PURCHASE_AGREEMENTS = 161,
  FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES_OTHER_AGREEMENTS = 162,
  FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES_SUBORDINATION_AGREEMENTS = 163,
  FINANCING_EQUITY = 164,
  FINANCING_EQUITY_PREFERRED_STOCK = 165,
  FINANCING_EQUITY_PREFERRED_STOCK_INVESTOR_RIGHTS_AGREEMENTS = 166,
  FINANCING_EQUITY_PREFERRED_STOCK_LEGAL_OPINIONS = 167,
  FINANCING_EQUITY_PREFERRED_STOCK_MANAGEMENT_LETTERS = 168,
  FINANCING_EQUITY_PREFERRED_STOCK_RIGHT_OF_FIRST_REFUSAL_AND_CO_SALE_AGREEMENTS = 169,
  FINANCING_EQUITY_PREFERRED_STOCK_VOTING_AGREEMENTS = 170,
  FINANCING_EQUITY_KISS = 171,
  FINANCING_EQUITY_OTHER = 172,
  FINANCING_EQUITY_PRESENTATIONS_TO_INVESTORS_OR_LENDERS = 173,
  FINANCING_EQUITY_SAFE_KISS = 174,
  FINANCING_EQUITY_SAFE_SIMPLE_AGREEMENT_FOR_FUTURE_EQUITY = 175,

  // CAT 7
  OTHER_DOCUMENTS = 176,

  MARKETING = 177,
  MARKETING_PRESS_RELEASES = 178,

  MISC_LEGAL_DOCUMENTS = 179,

  NON_LEGAL = 180,

  UNCATEGORIZED = 181,

  // MASTER
  MASTER = 9997,

  // GOD
  PLACEHOLDER = 9998,
  GOD_ENTRY = 9999,
}

export const MASTER_ENTRY: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.MASTER,
  name: "master",
  backendName: "Master",
  entries: [],
  type: GeneralFileNodeType.FOLDER,
};

export const OTHER_DOCUMENTS_ENTRIES: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.OTHER_DOCUMENTS,
  backendName: "Other Documents",
  name: "7. Other Documents",
  type: GeneralFileNodeType.FOLDER,
  entries: [
    {
      staticId: DATA_ROOM_STATIC_ID.MARKETING,
      name: "7.1 Marketing",
      backendName: "Marketing",
      type: GeneralFileNodeType.FOLDER,
      entries: [
        {
          staticId: DATA_ROOM_STATIC_ID.MARKETING_PRESS_RELEASES,
          backendName: "Marketing Press Releases",
          name: "Press Releases",
          type: GeneralFileNodeType.FOLDER,
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.MISC_LEGAL_DOCUMENTS,
      backendName: "Misc. Legal Documents",
      name: "7.2 Misc. Legal Documents",
      type: GeneralFileNodeType.FOLDER,
    },
    {
      staticId: DATA_ROOM_STATIC_ID.NON_LEGAL,
      backendName: "Non-legal",
      name: "7.3 Non-legal",
      type: GeneralFileNodeType.FOLDER,
    },
    {
      staticId: DATA_ROOM_STATIC_ID.UNCATEGORIZED,
      backendName: "Uncategorized",
      name: "7.4 Uncategorized",
      type: GeneralFileNodeType.FOLDER,
    },
  ],
};

export const FINANCE_ENTRIES: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.FINANCE,
  name: "6. Finance",
  backendName: "Finance",
  type: GeneralFileNodeType.FOLDER,
  entries: [
    {
      staticId: DATA_ROOM_STATIC_ID.BUDGETS_AND_PROJECTIONS,
      backendName: "Budgets and Projections",
      name: "6.1 Budgets and Projections",
      type: GeneralFileNodeType.FOLDER,
    },
    {
      staticId: DATA_ROOM_STATIC_ID.EXTERNAL_AUDITOR_REPORTS_AND_MANAGEMENT_GETTERS,
      backendName: "External Auditor Reports and Management Letters",
      type: GeneralFileNodeType.FOLDER,
      name: "6.2 External Auditor Reports and Management Getters",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.FEDERAL_STATE_AND_OTHER_TAX_FILINGS,
      name: "6.3 Federal, State, and Other Tax Filings",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Federal, State, and Other Tax Filings",
      entries: [
        {
          staticId: DATA_ROOM_STATIC_ID.FEDERAL_STATE_AND_OTHER_TAX_FILINGS_FORM_1120,
          type: GeneralFileNodeType.FOLDER,
          backendName: "Federal, State, and Other Tax Filings - Form 1120",
          name: "Form 1120",
        },
        {
          staticId: DATA_ROOM_STATIC_ID.FEDERAL_STATE_AND_OTHER_TAX_FILINGS_FORM_5500,
          backendName: "Federal, State, and Other Tax Filings - Form 5500",
          type: GeneralFileNodeType.FOLDER,
          name: "Form 5500",
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.FINANCIAL_STATEMENTS,
      name: "6.4 Financial Statements",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Financial Statements",
      entries: [
        {
          staticId: DATA_ROOM_STATIC_ID.FINANCIAL_STATEMENTS_AUDITED,
          backendName: "Financial Statements - Audited",
          type: GeneralFileNodeType.FOLDER,
          name: "Audited",
        },
        {
          staticId: DATA_ROOM_STATIC_ID.FINANCIAL_STATEMENTS_UNAUDITED,
          backendName: "Financial Statements - Unaudited",
          type: GeneralFileNodeType.FOLDER,
          name: "Unaudited",
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.FINANCE_OTHER,
      type: GeneralFileNodeType.FOLDER,
      backendName: "Finance - Other",
      name: "6.5 Other",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.TAX,
      backendName: "Tax",
      type: GeneralFileNodeType.FOLDER,
      name: "6.6 Tax",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.FINANCING,
      backendName: "Financing",
      type: GeneralFileNodeType.FOLDER,
      name: "6.7 Financing",
      entries: [
        {
          staticId: DATA_ROOM_STATIC_ID.FINANCING_DEBT,
          backendName: "Financing Debt",
          type: GeneralFileNodeType.FOLDER,
          name: "Debt",
          entries: [
            {
              staticId: DATA_ROOM_STATIC_ID.FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES,
              type: GeneralFileNodeType.FOLDER,
              backendName: "Financing - Debt - Promissory or Bridge Notes",
              name: "Promissory Or Bridge Notes",
              entries: [
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES_NOTE_PURCHASE_AGREEMENTS,
                  backendName: "Financing - Debt - Promissory or Bridge Notes - Note Purchase Agreements",
                  name: "Note Purchase Agreements",
                  type: GeneralFileNodeType.FOLDER,
                },
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES_OTHER_AGREEMENTS,
                  backendName: "Financing - Debt - Promissory or Bridge Notes - Other Agreements",
                  name: "Other Agreements",
                  type: GeneralFileNodeType.FOLDER,
                },
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_DEBT_PROMISSORY_OR_BRIDGE_NOTES_SUBORDINATION_AGREEMENTS,
                  backendName: "Financing - Debt - Promissory or Bridge Notes - Subordination Agreements",
                  name: "Subordination Agreements",
                  type: GeneralFileNodeType.FOLDER,
                },
              ],
            },
          ],
        },
        {
          staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY,
          name: "Equity",
          backendName: "Financing Equity",
          type: GeneralFileNodeType.FOLDER,
          entries: [
            {
              staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_PREFERRED_STOCK,
              name: "Preferred Stock",
              type: GeneralFileNodeType.FOLDER,
              backendName: "Financing Equity - Preferred Stock",
              entries: [
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_PREFERRED_STOCK_INVESTOR_RIGHTS_AGREEMENTS,
                  backendName: "Financing - Equity - Preferred Stock - Investor Rights Agreements",
                  name: "Investor Rights Agreements",
                  type: GeneralFileNodeType.FOLDER,
                },
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_PREFERRED_STOCK_LEGAL_OPINIONS,
                  backendName: "Financing - Equity - Preferred Stock - Legal Opinions",
                  name: "Legal Opinions",
                  type: GeneralFileNodeType.FOLDER,
                },
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_PREFERRED_STOCK_MANAGEMENT_LETTERS,
                  backendName: "Financing - Equity - Preferred Stock - Management Letters",
                  name: "Management Letters",
                  type: GeneralFileNodeType.FOLDER,
                },
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_PREFERRED_STOCK_RIGHT_OF_FIRST_REFUSAL_AND_CO_SALE_AGREEMENTS,
                  backendName: "Financing - Equity - Preferred Stock - Right of First Refusal and Co-Sale Agreements",
                  name: "Right of First Refusal And Co-Sale Agreements",
                  type: GeneralFileNodeType.FOLDER,
                },
                {
                  staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_PREFERRED_STOCK_VOTING_AGREEMENTS,
                  backendName: "Financing - Equity - Preferred Stock - Voting Agreements",
                  name: "Voting Agreements",
                  type: GeneralFileNodeType.FOLDER,
                },
              ],
            },
            {
              staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_KISS,
              backendName: "Financing - KISS",
              name: "KISS",
              type: GeneralFileNodeType.FOLDER,
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_OTHER,
              backendName: "Financing - Other",
              name: "Other",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_PRESENTATIONS_TO_INVESTORS_OR_LENDERS,
              backendName: "Financing - Presentation to Investors and Lenders",
              name: "Presentations to Investors or Lenders",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_SAFE_KISS,
              backendName: "Financing - SAFE/KISS",
              name: "SAFE/KISS",
              hidden: true,
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.FINANCING_EQUITY_SAFE_SIMPLE_AGREEMENT_FOR_FUTURE_EQUITY,
              backendName: "Financing - SAFE (Simple Agreement for Future Equity)",
              name: "Safe (Simple Agreement for Future Equity)",
            },
          ],
        },
      ],
    },
  ],
};

export const INTELLECTUAL_PROPERTY_ENTRIES: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.INTELLECTUAL_PROPERTY,
  backendName: "Intellectual Property",
  name: "5. Intellectual Property",
  type: GeneralFileNodeType.FOLDER,
  entries: [
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.COPYRIGHTS,
      backendName: "Copyrights",
      name: "5.1 Copyrights",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.DOMAIN_NAME_REGISTRATION,

      type: GeneralFileNodeType.FOLDER,
      backendName: "Domain Name Registration",
      name: "5.2 Domain Name Registration",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.END_USER_AGREEMENTS,
      backendName: "End User Agreements",
      name: "5.3 End User Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.IP_ASSIGNMENTS,
      backendName: "IP Assignments",
      name: "5.4 IP Assignments",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.LICENSE_AGREEMENTS,
      backendName: "License Agreements",
      name: "5.5 License Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.PATENTS,
      backendName: "Patents",
      name: "5.6 Patents",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.PUBLIC_DOMAIN_OR_OPEN_SOURCE,
      backendName: "Public Domain or Open Source",
      name: "5.7 Public Domain or Open Source",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.SOURCE_CODE_ESCROW_AGREEMENTS,
      backendName: "Source Code Escrow Agreements",
      name: "5.8 Source Code Escrow Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.TRADEMARKS,
      backendName: "Trademarks",
      name: "5.9 Trademarks",
    },
  ],
};

export const OPERATIONS_ENTRIES: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.OPERATIONS,
  backendName: "Operations",
  name: "4. Operations",
  type: GeneralFileNodeType.FOLDER,
  entries: [
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.BUSINESS_CONTINUITY_PLAN,
      backendName: "Business Continuity Plan",
      name: "4.1 Business Continuity Plan",
    },
    {
      type: GeneralFileNodeType.FOLDER,

      staticId: DATA_ROOM_STATIC_ID.CLIENT_AGREEMENTS,
      backendName: "Client Agreements",
      name: "4.2 Client Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.DISTRIBUTOR_AGREEMENTS,
      backendName: "Distributor Agreements",
      name: "4.3 Distributor Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.NON_DISCLOSURE_AGREEMENTS,
      backendName: "Non-Disclosure Agreements",
      name: "4.4 Non-Disclosure Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.PARTNERSHIP_AGREEMENTS,
      backendName: "Partnership Agreements",
      name: "4.5 Partnership Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STRATEGIC_OR_BUSINESS_PLANS,
      name: "4.6 Strategic or Business Plans",
      backendName: "Strategic or Business Plans",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.VENDOR_OR_SUPPLIER_AGREEMENTS,
      name: "4.7 Vendor or Supplier Agreements",
      backendName: "Vendor or Supplier Agreements",
    },
  ],
};

export const STOCKHOLDER_INFORMATION_ENTRIES: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.STOCKHOLDER_INFORMATION,
  name: "3. Stockholder Information",
  backendName: "Stockholder Information",
  type: GeneralFileNodeType.FOLDER,
  entries: [
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.CAPITALIZATION_TABLE,
      name: "3.1 Capitalization Table",
      backendName: "Capitalization Table",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.EQUITY_VALUATION_REPORTS,
      type: GeneralFileNodeType.FOLDER,
      name: "3.2 Equity Valuation Reports",
      backendName: "Equity Valuation Reports",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.EQUITY_VALUATION_REPORTS_409A_VALUATION,
          name: "409A Valuation",
          backendName: "409A Valuation",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.EQUITY_VALUATION_REPORTS_ASC_718,
          backendName: "ASC 718",
          name: "ASC 718",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.EQUITY_VALUATION_REPORTS_DRAFTS,
          name: "Drafts",
          backendName: "Drafts",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.EQUITY_VALUATION_REPORTS_FAIR_MARKET_VALUE_REQUEST_MATERIALS,
          name: "Fair Market Value Request Materials",
          backendName: "Fair Market Value Request Materials",
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.IRS_FILINGS,
      type: GeneralFileNodeType.FOLDER,
      name: "3.3 IRS Filings",
      backendName: "IRS Filings",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.IRS_FILINGS_3921,
          name: "3921",
          backendName: "IRS Filings - 3921",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.IRS_FILINGS_83_B,
          name: "83(b)",
          backendName: "IRS Filings - 83B",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.RESTRICTED_STOCK_UNIT_AGREEMENTS,
      name: "3.4 Restricted Stock Unit Agreements",
      backendName: "Restricted Stock Unit Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.RIGHT_OF_FIRST_REFUSAL_AND_CO_SALE_AGREEMENT,
      name: "3.5 Right of First Refusal and Co-Sale Agreement",
      backendName: "Right of First Refusal and Co-Sale Agreement",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STOCK_CANCELLATION,
      name: "3.6 Stock Cancellation",
      backendName: "Stock Cancellation",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.STOCK_CERTIFICATES,
      type: GeneralFileNodeType.FOLDER,
      name: "3.7 Stock Certificates",
      backendName: "Stock Certificates",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.STOCKHOLDER_AGREEMENTS,
      type: GeneralFileNodeType.FOLDER,
      name: "3.8 Stock Agreements",
      backendName: "Stockholder Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STOCKHOLDER_CONSENTS,
      name: "3.9 Stock Consents",
      backendName: "Stockholder Consents",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STOCKHOLDER_COMMUNICATIONS,
      name: "3.10 Stock Communications",
      backendName: "Stockholder Communications",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STOCK_INCENTIVE_PLANS,
      name: "3.11 Stock Incentive Plans",
      backendName: "Stock Incentive Plans",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STOCK_LEDGER,
      name: "3.12 Stock Ledger",
      backendName: "Stock Ledger",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.STOCK_OPTION_AGREEMENTS,
      name: "3.13 Stock Option Agreements",
      backendName: "Stock Option Agreements",
      type: GeneralFileNodeType.FOLDER,
      entries: [
        {
          staticId: DATA_ROOM_STATIC_ID.STOCK_OPTION_AGREEMENTS_EXERCISE_NOTICE,
          name: "Exercise Notice",
          type: GeneralFileNodeType.FOLDER,
          backendName: "Stock Option Agreements - Exercise Notice",
          entries: [
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.STOCK_OPTION_AGREEMENTS_EXERCISE_NOTICE_EXERCISE_EVIDENCE,
              name: "Exercise Evidence",
              backendName: "Stock Option Agreements - Exercise Evidence",
            },
          ],
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.STOCK_PURCHASE_AGREEMENTS,
      name: "3.14 Stock Purchase Agreements",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Stock Purchase Agreements",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.STOCK_PURCHASE_AGREEMENTS_ADDITIONAL_AGREEMENTS,
          name: "Additional Agreements",
          backendName: "Stock Purchase Agreements - Additional Agreements",
        },
        {
          staticId: DATA_ROOM_STATIC_ID.STOCK_PURCHASE_AGREEMENTS_COMMON_STOCK,
          name: "Common Stock",
          backendName: "Stock Purchase Agreements - Common Stock",
          type: GeneralFileNodeType.FOLDER,
          entries: [
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.STOCK_PURCHASE_AGREEMENTS_COMMON_STOCK_PURCHASE_EVIDENCE,
              name: "Purchase Evidence",
              backendName: "Common Stock Purchase Evidence",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.STOCK_PURCHASE_AGREEMENTS_COMMON_STOCK_STOCK_RESTRICTION_AGREEMENTS,
              name: "Stock Restriction Agreements",
              backendName: "Common Stock Restriction Agreements",
            },
          ],
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.STOCK_PURCHASE_AGREEMENTS_PREFERRED_STOCK,
          name: "Preferred Stock",
          backendName: "Stock Purchase Agreements - Preferred Stock",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STOCK_PURCHASE_EVIDENCE,
      name: "3.15 Stock Purchase Evidence",
      backendName: "Stock Purchase Evidence",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.STOCK_REPURCHASE_AGREEMENTS,
      name: "3.16 Stock Repurchase Agreements",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Stock Repurchase Agreements",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.STOCK_REPURCHASE_AGREEMENTS_REPURCHASE_EVIDENCE,
          name: "Repurchase Evidence",
          backendName: "Stock Repurchase Agreements - Repurchase Evidence",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.STOCK_TRANSFER_AGREEMENTS,
      name: "3.17 Stock Transfer Agreements",
      backendName: "Stock Transfer Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.WARRANT_AGREEMENTS,
      name: "3.18 Warrant Agreements",
      backendName: "Warrant Agreements",
    },
  ],
};

export const HUMAN_RESOURCES_ENTRIES: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.HUMAN_RESOURCES,
  name: "2. Human Resources",
  type: GeneralFileNodeType.FOLDER,
  backendName: "Human Resources",
  entries: [
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.ADVISOR_AGREEMENTS,
      name: "2.1 Advisor Agreements",
      backendName: "Advisor Agreements",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.BACKGROUND_CHECKS,
      type: GeneralFileNodeType.FOLDER,
      name: "2.2 Background Checks",
      backendName: "Background Checks",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.BACKGROUND_CHECKS_CONSENTS,
          name: "Consents",
          backendName: "Background Checks - Consents",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.BACKGROUND_CHECKS_RESULTS,
          name: "Results",
          backendName: "Background Checks - Results",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.BENEFITS_ENROLLMENTS,
      name: "2.3 Benefits Enrollments",
      backendName: "Benefits Enrollments",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.CODE_OF_CONDUCT,
      name: "2.4 Code of Conduct",
      backendName: "Code of Conduct",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.COMPANY_INFO,
      name: "2.5 Company Info",
      backendName: "Company Info",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.COMPANY_POLICIES,
      type: GeneralFileNodeType.FOLDER,
      name: "2.6 Company Policies",
      backendName: "Company Policies",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.COMPANY_POLICIES_POLICY_ACCEPTANCES,
          name: "Policy Acceptances",
          backendName: "Company Policies - Policy Acceptances",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.COMPENSATION,
      name: "2.7 Compensation",
      backendName: "Compensation",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.BONUS_PLAN,
      name: "2.8 Bonus Plan",
      backendName: "Bonus Plan",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.RETENTION_PLAN,
      name: "2.9 Retention Plan",
      backendName: "Retention Plan",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.SALES_COMMISSION_PLAN,
      name: "2.10 Sales Comission Plan",
      backendName: "Sales Commission Plan",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.CONSULTANT_AGREEMENTS,
      name: "2.11 Consultant Agreements",
      backendName: "Consultant Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.DIRECT_DEPOSIT_ENROLLMENTS,
      name: "2.12 Direct Deposit Enrollments",
      backendName: "Direct Deposit Enrollments",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.EEO_SURVEYS,
      name: "2.13 EEO Surveys",
      backendName: "EEO Surveys",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_AGREEMENTS,
      name: "2.14 Employee Agreements",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Employee Agreements",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_AGREEMENTS_COMPENSATION,
          name: "Compensation",
          backendName: "Employee Agreements - Compensation",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_AGREEMENTS_OTHER,
          name: "Other",
          backendName: "Employee Agreements - Other",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_BENEFIT_PROGRAMS,
      name: "2.15 Employee Benefit Programs",
      backendName: "Employee Benefit Programs",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_CONFIDENTIALITY_AND_IP_ASSIGNMENT_AGREEMENTS,
      name: "2.16 Employee Confidentiality and IP Assignment Agreements",
      backendName: "Employee Confidentiality and IP Assignment Agreements",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_FORMS,
      name: "2.17 Employee Forms",
      backendName: "Employee Forms",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_HANDBOOK,
      name: "2.18 Employee Handbook",
      backendName: "Employee Handbook",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.EMPLOYEE_JOB_CHANGE,
      name: "2.19 Employee Job Change",
      backendName: "Employee Job Change",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.I_94_FORMS,
      name: "2.20 I-94 Forms",
      backendName: "I-94 Forms",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.I_9_EVIDENCE,
      name: "2.21 I-9 Evidence",
      backendName: "I-9 Evidence",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.I_9_FORMS,
      name: "2.22 I-9 Forms",
      backendName: "I-9 Forms",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.JOB_DESCRIPTIONS,
      name: "2.23 Job Descriptions",
      backendName: "Job Descriptions",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.MISCELLANEOUS,
      name: "2.24 Miscellaneous",
      backendName: "Miscellaneous",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.OFFER_LETTERS,
      name: "2.25 Offer Letters",
      backendName: "Offer Letters",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.OFFER_LETTERS_EMPLOYMENT_CONTINGENCY_RESULTS,
      name: "2.26 Offer Letters Employment Contingency Results",
      backendName: "Offer Letters: Employment Contingency Results",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.HUMAN_RESOURCES_ORGANIZATIONAL_CHART,
      name: "2.27 Organizational Chart",
      backendName: "HR-Organizational Chart",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.HUMAN_RESOURCES_OTHER,
      name: "2.28 Other",
      backendName: "HR-Others",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.PERFORMANCE_MANAGEMENT,
      name: "2.29 Performance Management",
      backendName: "Perforce Management",
      type: GeneralFileNodeType.FOLDER,
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.PERFORMANCE_MANAGEMENT_PERFORMANCE_IMPROVEMENT_PLANS,
          name: "Performance Improvement Plans",
          backendName: "Performance Management - Performance Improvement Plans",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.PERFORMANCE_MANAGEMENT_PERFORMANCE_REVIEW,
          name: "Performance Review",
          backendName: "Performance Management - Performance Review",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.RESUMES,
      name: "2.30 Resumes",
      backendName: "Resumes",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.SEPARATION_DOCUMENTS,
      name: "2.31 Separation Documents",
      backendName: "Separation Documents",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.W_4_FORMS,
      name: "2.32 W-4 Forms",
      backendName: "W-4 Forms",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.W_9_FORMS,
      name: "2.33 W-9 Forms",
      backendName: "W-9 Forms",
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.WORKERS_COMPENSATION,
      name: "2.34 Workers Compensation",
      backendName: "Workers Compensation",
    },
  ],
};

export const CORPORATE_ENTRIES: DataRoomEntry = {
  staticId: DATA_ROOM_STATIC_ID.CORPORATE,
  type: GeneralFileNodeType.FOLDER,
  name: "1. Corporate",
  backendName: "Corporate",
  entries: [
    {
      staticId: DATA_ROOM_STATIC_ID.CORPORATE_RECORDS,
      name: "1.1 Corporate Records",
      backendName: "Corporate Records",
      type: GeneralFileNodeType.FOLDER,
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.ANNUAL_REPORTS,
          name: "Annual Reports",
          backendName: "Annual Reports",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.BY_LAWS,
          name: "By-Laws",
          backendName: "By-Laws",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.CHARTER_DOCUMENTS,
          name: "Charter Documents",
          backendName: "Charter Documents",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.CORPORATE_ORGANIZATIONAL_CHART,
          name: "Corporate Organizational Chart",
          backendName: "Corporate Organizational Chart",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.FOREIGN_STATE_REGISTRATION,
          name: "Foreign State Registration",
          backendName: "Foreign State Registration",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.FOUNDERS_AGREEMENT,
          name: "Founders Agreement",
          backendName: "Founders Agreement",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.LLC_CONVERSION,
          name: "LLC Conversion",
          backendName: "LLC Conversion",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.CORPORATE_RECORDS_OTHER,
          name: "Other",
          backendName: "Corporate Records - Other",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.REGISTERED_AGENT,
          name: "Registered Agent",
          backendName: "Registered Agent",
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.CORPORATE_GOVERNANCE,
      name: "1.2 Corporate Governance",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Corporate Governance",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.BOARD_BOOKS,
          name: "Board Books",
          backendName: "Board Books",
        },
        {
          staticId: DATA_ROOM_STATIC_ID.BOARD_COMMITTEES,
          name: "Board Committees",
          backendName: "Board Committees",
          type: GeneralFileNodeType.FOLDER,
          entries: [
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.BOARD_COMMITTEES_COMMITTEE_CHARTERS,
              name: "Committee Charters",
              backendName: "Committee Charters",
            },
          ],
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.CODE_OF_ETHICS,
          name: "Code of Ethics",
          backendName: "Code of Ethics",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.DIRECTOR_OR_OFFICER_INDEMNIFICATION_AGREEMENTS,
          name: "Director or Officer Indemnification Agreements",
          backendName: "Director or Officer Indemnification Agreements",
        },
        {
          staticId: DATA_ROOM_STATIC_ID.MINUTES,
          type: GeneralFileNodeType.FOLDER,
          name: "Minutes",
          backendName: "Minutes",
          entries: [
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.MINUTES_BOARD_MEETINGS,
              name: "Board Meetings",
              backendName: "Board Meetings",
            },
            {
              staticId: DATA_ROOM_STATIC_ID.MINUTES_COMMITTEE_MEETINGS,
              name: "Committee Meetings",
              backendName: "Minutes Committee Meetings",
              type: GeneralFileNodeType.FOLDER,
              entries: [
                {
                  type: GeneralFileNodeType.FOLDER,
                  staticId: DATA_ROOM_STATIC_ID.MINUTES_COMMITTEE_MEETINGS_AUDIT_COMMITTEE,
                  name: "Audit Committee",
                  backendName: "Board Meetings - Audit Committee",
                },
                {
                  type: GeneralFileNodeType.FOLDER,
                  staticId: DATA_ROOM_STATIC_ID.MINUTES_COMMITTEE_MEETINGS_COMPENSATION_COMMITTEE,
                  name: "Compensation Committee",
                  backendName: "Board Meetings - Compensation Committee",
                },
              ],
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.MINUTES_STOCKHOLDER_MEETINGS,
              name: "Stockholder Meetings",
              backendName: "Stockholder Meetings",
            },
          ],
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.RESIGNATION,
          name: "Resignation",
          backendName: "Resignation",
        },
        {
          staticId: DATA_ROOM_STATIC_ID.WRITTEN_CONSENTS,
          name: "Written Consents",
          type: GeneralFileNodeType.FOLDER,
          backendName: "Written Consents",
          entries: [
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.WRITTEN_CONSENTS_BOARD_COMMITTEES,
              name: "Board Committees",
              backendName: "Written Consents Committees",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.WRITTEN_CONSENTS_BOARD_COMMITTEES_AUDIT_COMMITTEE,
              name: "Audit Committee",
              backendName: "Written Consents - Audit Committee",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.WRITTEN_CONSENTS_BOARD_COMMITTEES_COMPENSATION_COMMITTEE,
              name: "Compensation Committee",
              backendName: "Written Consents - Compensation Committee",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.WRITTEN_CONSENTS_BOARD_OF_DIRECTORS,
              name: "Board of Directors",
              backendName: "Written Consents - Board of Directors",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.WRITTEN_CONSENTS_STOCKHOLDERS,
              name: "Stockholders",
              backendName: "Written Consents - Stockholders",
            },
          ],
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.INSURANCE,
      name: "1.3 Insurance",
      backendName: "Insurance",
      type: GeneralFileNodeType.FOLDER,
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.INSURANCE_CLAIMS_OR_NOTICES_OF_CIRCUMSTANCES,
          name: "Insurance Claims or Notices of Circumstances",
          backendName: "Insurance Claims or Notices of Circumstances",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.INSURANCE_POLICIES,
          name: "Insurance Policies",
          backendName: "Insurance Policies",
          entries: [
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.INSURANCE_POLICIES_D_AND_O_INSURANCE,
              name: "D&O Insurance",
              backendName: "Insurance - D&O Insurance",
            },
            {
              type: GeneralFileNodeType.FOLDER,
              staticId: DATA_ROOM_STATIC_ID.INSURANCE_POLICIES_KEY_PERSON_INSURANCE,
              name: "Key Person Insurance",
              backendName: "Insurance - Key Person Insurance",
            },
          ],
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.LITIGATION,
      name: "1.4 Litigation",
      backendName: "Litigation",
      type: GeneralFileNodeType.FOLDER,
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.DEMAND_LETTERS,
          name: "Demand Letters",
          backendName: "Demand Letters",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.EXTERNAL_OR_INTERNAL_INVESTIGATIONS,
          name: "External or Internal Investigations",
          backendName: "External or Internal Investigations",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.PLEADINGS,
          name: "Pleadings",
          backendName: "Pleadings",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.REGULATORY_ENFORCEMENT_ACTION,
          name: "Regulatory Enforcement Action",
          backendName: "Regulatory Enforcement Action",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.LITIGATION_SETTLEMENT_AGREEMENTS,
          name: "Settlement Agreements",
          backendName: "Settlement Agreements",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.LITIGATION_SUBPOENAS,
          name: "Subpoenas",
          backendName: "Litigations Subpoenas",
        },
      ],
    },
    {
      staticId: DATA_ROOM_STATIC_ID.PROPERTIES_ASSETS_AND_LEASES,
      name: "1.5 Properties, Assets, and Leases",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Properties, Assets, and Leases",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.ENVIRONMENTAL_REPORTS,
          name: "Environmental Reports",
          backendName: "Environmental Reports",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.LEASES,
          name: "Leases",
          backendName: "Leases",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.PURCHASE_AND_SALE_AGREEMENTS,
          name: "Purchase and Sale Agreements",
          backendName: "Properties, Assets, and Leases Settlement Agreements",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.SUBLEASES,
          name: "Subleases",
          backendName: "Subleases",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.PROPERTIES_ASSETS_AND_LEASES_SETTLEMENT_AGREEMENTS,
          name: "Settlement Agreements",
          backendName: "Properties, Assets, and Leases Settlement Agreements",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.PROPERTIES_ASSETS_AND_LEASES_SUBPOENAS,
          name: "Subpoenas",
          backendName: "Properties - Subpoenas",
        },
      ],
    },
    {
      type: GeneralFileNodeType.FOLDER,
      staticId: DATA_ROOM_STATIC_ID.ACQUISITIONS,
      name: "1.6 Acquisitions",
      backendName: "Acquisitions",
    },
    {
      staticId: DATA_ROOM_STATIC_ID.REGULATORY_AND_COMPLIANCE,
      name: "1.7 Regulatory and Compliance",
      type: GeneralFileNodeType.FOLDER,
      backendName: "Regulatory and Compliance",
      entries: [
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.ALL_SEC_AND_BLUE_SKY_FILINGS,
          name: "All SEC and Blue Sky Filings",
          backendName: "All SEC and Blue Sky filings",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.AUDIT_REPORTS,
          name: "Audit Reports",
          backendName: "Audit Reports",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.GOVERNMENT_AUTHORIZATIONS_LICENSES_OR_PERMITS,
          name: "Government Authorizations Licenses or Permits",
          backendName: "Government Authorizations, Licenses, or Permits",
        },
        {
          type: GeneralFileNodeType.FOLDER,
          staticId: DATA_ROOM_STATIC_ID.REGULATORY_FILINGS,
          name: "Regulatory Filings",
          backendName: "Regulatory Filings",
        },
      ],
    },
  ],
};

export const ALL_ENTRIES_SEPARATED = [
  CORPORATE_ENTRIES,
  HUMAN_RESOURCES_ENTRIES,
  STOCKHOLDER_INFORMATION_ENTRIES,
  OPERATIONS_ENTRIES,
  INTELLECTUAL_PROPERTY_ENTRIES,
  FINANCE_ENTRIES,
  OTHER_DOCUMENTS_ENTRIES,
];

export const ENTRIES_EXCLUDED_FROM_SELECTION = ALL_ENTRIES_SEPARATED.map((e) => e.staticId);

export const ALL_ENTRIES_JOINED: DataRoomEntry = {
  type: GeneralFileNodeType.FOLDER,
  staticId: DATA_ROOM_STATIC_ID.GOD_ENTRY,
  name: "no-name-god",
  backendName: "God Entry",
  entries: ALL_ENTRIES_SEPARATED,
};

export enum ROOT_CATEGORIES {
  CORPORATE = "CORPORATE",
  HUMAN_RESOURCES = "HUMAN RESOURCES",
  STOCKHOLDER_INFORMATION = "STOCKHOLDER INFORMATION",
  OPERATIONS = "OPERATIONS",
  INTELLECTUAL_PROPERTY = "INTELLECTUAL PROPERTY",
  FINANCE = "FINANCE",
  OTHER_DOCUMENTS = "OTHER DOCUMENTS",
}

export function matchEntryNamesByTerm(term: string): DataRoomEntry[] {
  if (term.length < 2) return [];
  term = term.trim().toLowerCase();
  let matches = [];
  let stack: DataRoomEntry[][] = [ALL_ENTRIES_SEPARATED];
  while (stack.length > 0) {
    let entries = stack.pop();
    for (let e of entries) {
      if (e.name.toLowerCase().includes(term)) {
        matches.push(e);
      }
      if (e.entries) {
        stack.push(e.entries);
      }
    }
  }
  return matches;
}

export function findEntryByStaticId(targetStaticId: DATA_ROOM_STATIC_ID): DataRoomEntry | null {
  let stack: DataRoomEntry[][] = [ALL_ENTRIES_SEPARATED.concat(MASTER_ENTRY)];
  while (stack.length > 0) {
    let entryArray = stack.pop();
    for (let e of entryArray) {
      if (e.staticId === targetStaticId) {
        return e;
      } else if (e.entries) {
        stack.push(e.entries);
      }
    }
  }
  return null;
}

export function findPathByStaticId(targetStaticId: DATA_ROOM_STATIC_ID): string | null {
  function search(entries: DataRoomEntry[], path: string[]): string | null {
    for (const entry of entries) {
      const currentPath = [...path, entry.name];

      if (entry.staticId === targetStaticId) {
        return currentPath.join(" / ");
      }

      if (entry.entries) {
        const result = search(entry.entries, currentPath);
        if (result) return result;
      }
    }
    return null;
  }

  return search(ALL_ENTRIES_SEPARATED, []);
}
